// language=GraphQL
export const ALL_CUSTOM_DATA_CONFIGS_QUERY = `query Query($withTravellerForm: Boolean = false, $withTravellerFormFields: Boolean = false, $withTravellerFormFieldsOptions: Boolean = false, $withTravellerFormFieldsVisibilityConfig: Boolean = false, $withBookingForm: Boolean = false, $withBookingFormFields: Boolean = false, $withBookingFormFieldsOptions: Boolean = false, $withBookingFormFieldsVisibilityConfig: Boolean = false) {
  customDataConfigs: travelPricingCustomDataConfigs {
    id
    useTravellerForm
    travellerForm @include(if: $withTravellerForm) {
      id
      fields @include(if: $withTravellerFormFields) {
        id
        inputType
        name
        label
        info
        value
        required
        options @include(if: $withTravellerFormFieldsOptions) {
          id
          value
          label
        }
        visibilityConfig @include(if: $withTravellerFormFieldsVisibilityConfig) {
          id
        }
        heading
      }
    }
    useBookingForm
    bookingForm @include(if: $withBookingForm) {
      id
      fields @include(if: $withBookingFormFields) {
        id
        inputType
        name
        label
        info
        value
        required
        options @include(if: $withBookingFormFieldsOptions) {
          id
          value
          label
        }
        visibilityConfig @include(if: $withBookingFormFieldsVisibilityConfig) {
          id
        }
        heading
      }
    }
  }
}`

// language=GraphQL
export const SINGLE_CUSTOM_DATA_CONFIG_QUERY = `query Query($id: ID!, $withTravellerForm: Boolean = false, $withTravellerFormFields: Boolean = false, $withTravellerFormFieldsOptions: Boolean = false, $withTravellerFormFieldsVisibilityConfig: Boolean = false, $withBookingForm: Boolean = false, $withBookingFormFields: Boolean = false, $withBookingFormFieldsOptions: Boolean = false, $withBookingFormFieldsVisibilityConfig: Boolean = false) {
  customDataConfig: travelPricingCustomDataConfig(id: $id) {
    id
    useTravellerForm
    travellerForm @include(if: $withTravellerForm) {
      id
      fields @include(if: $withTravellerFormFields) {
        id
        inputType
        name
        label
        info
        value
        required
        options @include(if: $withTravellerFormFieldsOptions) {
          id
          value
          label
        }
        visibilityConfig @include(if: $withTravellerFormFieldsVisibilityConfig) {
          id
        }
        heading
      }
    }
    useBookingForm
    bookingForm @include(if: $withBookingForm) {
      id
      fields @include(if: $withBookingFormFields) {
        id
        inputType
        name
        label
        info
        value
        required
        options @include(if: $withBookingFormFieldsOptions) {
          id
          value
          label
        }
        visibilityConfig @include(if: $withBookingFormFieldsVisibilityConfig) {
          id
        }
        heading
      }
    }
  }
}`

// language=GraphQL
export const CREATE_CUSTOM_DATA_CONFIG_MUTATION = `
  mutation Mutation($input: CreateTravelPricingCustomDataConfigInput, $withTravellerForm: Boolean = false, $withTravellerFormFields: Boolean = false, $withTravellerFormFieldsOptions: Boolean = false, $withTravellerFormFieldsVisibilityConfig: Boolean = false, $withBookingForm: Boolean = false, $withBookingFormFields: Boolean = false, $withBookingFormFieldsOptions: Boolean = false, $withBookingFormFieldsVisibilityConfig: Boolean = false) {
    customDataConfig: createTravelPricingCustomDataConfig(input: $input) {
      id
      useTravellerForm
      travellerForm @include(if: $withTravellerForm) {
        id
        fields @include(if: $withTravellerFormFields) {
          id
          inputType
          name
          label
          info
          value
          required
          options @include(if: $withTravellerFormFieldsOptions) {
            id
            value
            label
          }
          visibilityConfig @include(if: $withTravellerFormFieldsVisibilityConfig) {
            id
          }
          heading
        }
      }
      useBookingForm
      bookingForm @include(if: $withBookingForm) {
        id
        fields @include(if: $withBookingFormFields) {
          id
          inputType
          name
          label
          info
          value
          required
          options @include(if: $withBookingFormFieldsOptions) {
            id
            value
            label
          }
          visibilityConfig @include(if: $withBookingFormFieldsVisibilityConfig) {
            id
          }
          heading
        }
      }
    }
  }`

// language=GraphQL
export const UPDATE_CUSTOM_DATA_CONFIG_MUTATION = `
  mutation Mutation($input: UpdateTravelPricingCustomDataConfigInput, $withTravellerForm: Boolean = false, $withTravellerFormFields: Boolean = false, $withTravellerFormFieldsOptions: Boolean = false, $withTravellerFormFieldsVisibilityConfig: Boolean = false, $withBookingForm: Boolean = false, $withBookingFormFields: Boolean = false, $withBookingFormFieldsOptions: Boolean = false, $withBookingFormFieldsVisibilityConfig: Boolean = false) {
    customDataConfig: updateTravelPricingCustomDataConfig(input: $input) {
      id
      useTravellerForm
      travellerForm @include(if: $withTravellerForm) {
        id
        fields @include(if: $withTravellerFormFields) {
          id
          inputType
          name
          label
          info
          value
          required
          options @include(if: $withTravellerFormFieldsOptions) {
            id
            value
            label
          }
          visibilityConfig @include(if: $withTravellerFormFieldsVisibilityConfig) {
            id
          }
          heading
        }
      }
      useBookingForm
      bookingForm @include(if: $withBookingForm) {
        id
        fields @include(if: $withBookingFormFields) {
          id
          inputType
          name
          label
          info
          value
          required
          options @include(if: $withBookingFormFieldsOptions) {
            id
            value
            label
          }
          visibilityConfig @include(if: $withBookingFormFieldsVisibilityConfig) {
            id
          }
          heading
        }
      }
    }
  }`

// language=GraphQL
export const DELETE_CUSTOM_DATA_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingCustomDataConfigInput) {
    deleteTravelPricingCustomDataConfig(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_CUSTOM_DATA_CONFIG_MUTATION = `
  mutation Mutation($input: DeleteTravelPricingCustomDataConfigInput) {
    forceDeleteTravelPricingCustomDataConfig(input: $input) {
      success
    }
  }`
// language=GraphQL
export const CUSTOM_DATA_CONFIGS_DEPENDENTS_QUERY = `query Query($id: ID!, $withTravelPricings: Boolean = false) {
  groupedDependents: travelPricingCustomDataConfigDependents(id: $id) {
    travelPricings @include(if: $withTravelPricings) {
      id
      isTravelDocumentationAvailable
    }
  }
}`
